export default __webpack_public_path__ + "static/media/lapt-full.9adeee5d.png";